(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 58671:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(40790);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Custom404": function() { return /* binding */ Custom404; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68239);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22430);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69417);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _Layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68421);
/* harmony import */ var _styles_modules_404_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80491);
/* harmony import */ var _styles_modules_404_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_404_module_scss__WEBPACK_IMPORTED_MODULE_6__);






var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    palette: {
        primary: {
            main: "#00454A"
        },
        secondary: {
            main: "#202020"
        }
    },
    typography: {
        fontFamily: '"Libre Franklin", sans-serif',
        color: "#202020"
    }
});
function Custom404() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        theme: theme,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_modules_404_module_scss__WEBPACK_IMPORTED_MODULE_6___default().notFoundContainer), "container"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: "block font-garamond",
                    children: "404!"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "font-garamond",
                    children: "This page could not be found."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "font-libre",
                    children: "Your journey has taken an unexpected detour. While we couldn't find the exact destination you were seeking, there are countless other wonders waiting to be explored. Perhaps this is a sign to wander off the beaten path, discover hidden gems, or embark on a completely new adventure. Remember, the most memorable journeys often begin with a wrong turn. So, pack your bags, let your spirit guide you, and embrace the unexpected. Your next unforgettable adventure with BusinessClass.com awaits. If you're looking for any community related stuff, try searching the Forum."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    variant: "outlined",
                    color: "secondary",
                    className: "mt-2",
                    type: "button",
                    onClick: function() {
                        document.location = "/";
                    },
                    children: "Click here to go to frontpage."
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["default"] = ((0,_Layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* .withLayout */ .X)(Custom404, false));


/***/ }),

/***/ 80491:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"notFoundContainer":"__404_notFoundContainer__4DEi_"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,4231,129,1979,7088,9125,2828,632,9780,4857,8421,9774,2888,179], function() { return __webpack_exec__(58671); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);